__turbopack_context__.v({
  "wrap": "HeroSciencesBackground-module__JbTYPq__wrap",
});
